(function () {
  var desktopQuery = window.matchMedia('(min-width: 990px)');

  function bindGalleryArrows(gallery) {
    var buttons = gallery.querySelector('.slider-buttons');
    if (!buttons) return;

    var mediaGallery = gallery.closest('media-gallery');
    if (!mediaGallery) return;

    var prevButton = buttons.querySelector('.slider-button--prev');
    var nextButton = buttons.querySelector('.slider-button--next');

    function step(direction) {
      if (!desktopQuery.matches) return;
      if (typeof mediaGallery.setActiveMedia !== 'function') return;

      var items = Array.prototype.slice.call(gallery.querySelectorAll('.product__media-item[data-media-id]'));
      if (items.length < 2) return;

      var currentIndex = items.findIndex(function (item) {
        return item.classList.contains('is-active');
      });
      if (currentIndex === -1) currentIndex = 0;

      var nextIndex = (currentIndex + direction + items.length) % items.length;
      mediaGallery.setActiveMedia(items[nextIndex].dataset.mediaId, false, false);
    }

    if (prevButton) prevButton.addEventListener('click', function () { step(-1); });
    if (nextButton) nextButton.addEventListener('click', function () { step(1); });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('product-gallery.slider-mobile--overlay').forEach(bindGalleryArrows);
  });
})();
